export default __webpack_public_path__ + "static/media/clapMusic.bbac1f19.mp3";